import styles from "./Contact.module.css";
import Reveal from "./Reveal";
import Icon from "./Icons";
import BookingForm from "./BookingForm";
import { areasServed } from "../data/content";
import useSiteSettings from "../hooks/useSiteSettings";

export default function Contact({ headless = false }) {
  const { doctor, contact } = useSiteSettings();
  return (
    <section id="contact" className={`u-section ${styles.section}`}>
      <div className={`u-shell ${styles.grid}`}>
        <Reveal className={styles.main}>
          {!headless && (
            <div className={styles.intro}>
              <p className="u-eyebrow">{contact.eyebrow}</p>
              <h2 className="u-h2">{contact.heading}</h2>
              <p className="u-lead">{contact.intro}</p>
            </div>
          )}

          <BookingForm />
        </Reveal>

        <Reveal className={styles.aside} delay={90}>
          <div className={styles.channels}>
            <a href={`tel:${doctor.phoneHref}`} className={styles.channel}>
              <span className={styles.channelIcon}>
                <Icon name="phone" size={20} />
              </span>
              <span className={styles.channelCopy}>
                <span className={styles.channelLabel}>Call</span>
                <span className={styles.channelValue}>{doctor.phone}</span>
              </span>
              <Icon name="arrow" size={18} className={styles.channelArrow} />
            </a>

            <a href={`mailto:${doctor.email}`} className={styles.channel}>
              <span className={styles.channelIcon}>
                <Icon name="mail" size={20} />
              </span>
              <span className={styles.channelCopy}>
                <span className={styles.channelLabel}>Email</span>
                <span className={styles.channelValue}>{doctor.email}</span>
              </span>
              <Icon name="arrow" size={18} className={styles.channelArrow} />
            </a>
          </div>

          <div className={styles.card}>
            <div className={styles.cardHead}>
              <span className={styles.cardIcon}>
                <Icon name="clock" size={20} />
              </span>
              <h2 className={styles.cardTitle}>Consultation hours</h2>
            </div>

            <dl className={styles.hours}>
              {contact.hours.map((slot) => (
                <div key={slot.day} className={styles.slot}>
                  <dt className={styles.day}>{slot.day}</dt>
                  <dd className={styles.time}>{slot.time}</dd>
                </div>
              ))}
            </dl>

            <div className={styles.place}>
              <Icon name="pin" size={18} />
              <span>{doctor.location}</span>
            </div>

            <p className={styles.note}>{contact.note}</p>
          </div>

          <div className={styles.areas}>
            <h2 className={styles.areasTitle}>Areas covered in Gurugram</h2>
            <ul className={styles.areaList}>
              {areasServed.map((area) => (
                <li key={area}>{area}</li>
              ))}
            </ul>
            <p className={styles.areasNote}>
              Not on the list? Ask — most of Gurugram is reachable for home
              visits.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
